import { Layout } from "antd";
import styled from "styled-components";

const { Content } = Layout;

export const FormConditionFields = styled(Content)`
    padding: 0 30px;
`;
